import { render } from "./document-view-simple-text.vue?vue&type=template&id=0d3d5524&scoped=true&lang=html"
import script from "./document-view-simple-text.vue?vue&type=script&lang=js"
export * from "./document-view-simple-text.vue?vue&type=script&lang=js"

import "./document-view-simple-text.vue?vue&type=style&index=0&id=0d3d5524&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3d5524"]])

export default __exports__